import type { ReactNode } from "react";
import { PluginTrpcProvider as UiPluginTrpcProvider, type PluginTrpcClient } from "@webtemplate/ui";
import { trpc } from "./trpc";

/**
 * App-side plugin tRPC provider (DECOUPLE-04 / D-04, Plan 06).
 *
 * Mounts the app's typed `trpc` client into the `@webtemplate/ui`
 * `PluginTrpcContext` so plugin client surfaces can read it via
 * `usePluginTrpc()` instead of importing `client/src/core/api`.
 *
 * THIS is the single `as any` cast site that replaces the 6 per-plugin
 * `coreTrpc as any` shims: the typed `trpc` (carrying the app's `AppRouter`
 * type) is cast to the opaque `PluginTrpcClient` here, app-side, so the
 * `AppRouter` type never enters a plugin (Pitfall 3).
 *
 * Mirrors `AuthProvider`/`FeatureFlagProvider`: the provider lives in the app,
 * the context lives in `@webtemplate/ui`.
 */
export function PluginTrpcProvider({ children }: { children: ReactNode }) {
  return (
    <UiPluginTrpcProvider value={trpc as unknown as PluginTrpcClient}>
      {children}
    </UiPluginTrpcProvider>
  );
}
